import {
  Pipe,
  PipeTransform
} from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, Tag } from '../../app.models';

@Pipe({ name: 'tagcol' })
export class TagColPipe implements PipeTransform {
  transform(tags: Tag[]): string {
    return tags.map(t => t.name)
      .join(', ')
  }
}

@Pipe({ name: 'tagcolWithNumber' })
export class TagColWithNumberPipe implements PipeTransform {
  transform(tags: Tag[]) {
    const tagNames = tags.map(t => t.name).join(', ')
    const tagLength = tags.length;
    const tagNamesAndLength = [tagNames, tagLength]
    return tagNamesAndLength
  }
}

@Pipe({ name: 'tagcolFromIds' })
export class TagColFromIdsPipe implements PipeTransform {
  tags: Tag[]=[];
  constructor(
    private store: Store,
  ) {
    this.store.select((state: AppState) => state.tags)
      .subscribe(tags => {
        this.tags = tags;
      });
  }
  transform(tagIds: number[], tags: Tag[] = null): string {
    return tagIds.map(id => this.tags.find(t => t.id === id)?.name || id).join(', ')
  }
}
